import { render, staticRenderFns } from "./reportgoods.vue?vue&type=template&id=4620c7fa&scoped=true&"
import script from "./reportgoods.vue?vue&type=script&lang=js&"
export * from "./reportgoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4620c7fa",
  null
  
)

export default component.exports